import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'
//@ts-ignore
import { GridContainer, FakeInput } from 'shared/StyledComponents'
import translate from '../../../translator'

const InfoDataTable = ({ data }) => (
  <GridContainer style={{ marginTop: 20 }}>
    <Grid>
      <Grid.Row>
        <Grid.Column width={1} />

        <Grid.Column width={9}>
          <FakeInput>
            <Segment>{translate('lbl_osbalance_t')}</Segment>
          </FakeInput>
        </Grid.Column>

        <Grid.Column width={5}>
          <FakeInput>
            <Segment>{data.OSBalance}</Segment>
          </FakeInput>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={1} />

        <Grid.Column width={9}>
          <FakeInput>
            <Segment>{translate('lbl_reserve_rate_t')}</Segment>
          </FakeInput>
        </Grid.Column>

        <Grid.Column width={5}>
          <FakeInput>
            <Segment>{data.Rate} %</Segment>
          </FakeInput>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={1} />

        <Grid.Column width={9}>
          <FakeInput>
            <Segment>{translate('lbl_reserve_amount_par_t')}</Segment>
          </FakeInput>
        </Grid.Column>

        <Grid.Column width={5}>
          <FakeInput>
            <Segment>{data.AmountPAR}</Segment>
          </FakeInput>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={1} />

        <Grid.Column width={9}>
          <FakeInput>
            <Segment>{translate('lbl_reserve_amount_pia_t')}</Segment>
          </FakeInput>
        </Grid.Column>

        <Grid.Column width={5}>
          <FakeInput>
            <Segment>{data.AmountPIA}</Segment>
          </FakeInput>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={1} />

        <Grid.Column width={9}>
          <FakeInput>
            <Segment>{translate('lbl_reserve_amount_t')}</Segment>
          </FakeInput>
        </Grid.Column>

        <Grid.Column width={5}>
          <FakeInput>
            <Segment>{data.Amount}</Segment>
          </FakeInput>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </GridContainer>
)

InfoDataTable.defaultProps = {
  data: {},
}

export default InfoDataTable
